import React, { useState } from 'react';

const KalkulatorKucista = () => {
    const [sirina, setSirina] = useState(100);
    const [visina, setVisina] = useState(100);
    const [tipKucista, setTipKucista] = useState('alubond');

    const kursEura = 118;

    const izracunajCenuEura = () => {
        const sirinaMm = sirina * 10;
        const visinaMm = visina * 10;
        const povrsinaM2 = (sirinaMm * visinaMm) / 1000000;
        let cenaPoM2 = 150;

        if (tipKucista === 'alubond') {
            cenaPoM2 = 82;
        } else if (tipKucista === 'alubond_sa_poklopcem') {
            cenaPoM2 = 114;
        }

        const ukupno = povrsinaM2 * cenaPoM2;
        return isNaN(ukupno) ? 0 : Number(ukupno.toFixed(2));
    };

    const ukupnoEur = izracunajCenuEura();
    const ukupnoDin = (ukupnoEur * kursEura).toFixed(2);

    return (
        <div style={{ color: 'white', padding: '20px', maxWidth: '600px' }}>
            <h2>Kalkulator cene kućišta za ekrane</h2>
            
            <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>Širina (cm):</label>
                <input 
                    type="number" 
                    value={sirina} 
                    onChange={(e) => setSirina(Number(e.target.value))} 
                    style={{ width: '100%', padding: '8px', background: '#162447', color: 'white', border: '1px solid #1a2a4a', borderRadius: '4px' }}
                />
            </div>

            <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>Visina (cm):</label>
                <input 
                    type="number" 
                    value={visina} 
                    onChange={(e) => setVisina(Number(e.target.value))} 
                    style={{ width: '100%', padding: '8px', background: '#162447', color: 'white', border: '1px solid #1a2a4a', borderRadius: '4px' }}
                />
            </div>

            <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>Tip kućišta:</label>
                <select 
                    value={tipKucista} 
                    onChange={(e) => setTipKucista(e.target.value)}
                    style={{ width: '100%', padding: '8px', background: '#162447', color: 'white', border: '1px solid #1a2a4a', borderRadius: '4px' }}
                >
                    <option value="alubond">Alubond</option>
                    <option value="alubond_sa_poklopcem">Alubond sa poklopcem</option>
                </select>
            </div>

            <div style={{ padding: '15px', background: '#162447', borderRadius: '6px', border: '1px solid #3366ff' }}>
                <h3 style={{ margin: '0 0 10px 0' }}>Ukupna cena:</h3>
                <p style={{ fontSize: '20px', margin: '5px 0', color: '#3366ff', fontWeight: 'bold' }}>{ukupnoEur} EUR</p>
                <p style={{ fontSize: '18px', margin: '5px 0', color: '#00ffcc' }}>{ukupnoDin} RSD</p>
            </div>
        </div>
    );
};

export default KalkulatorKucista;